import { useMemo } from 'react'

import { useQuery } from 'react-query'

import { SessionApproverChoice } from '@webapp/modules/accounts-payable/entities/SessionApproverChoice'
import { reconcileSessionQueries } from '@webapp/modules/accounts-payable/query-configs/reconcileSessionQueries'

interface IUseQuerySessionApproverChoicesParams {
  sessionId: number
  /** Only fires once a chain is selected (BHV-046) */
  approvalChainId: Nullable<number>
  onError?: (err: unknown) => void
}

interface IUseQuerySessionApproverChoicesReturn {
  choices: SessionApproverChoice[]
  isLoading: boolean
  isFetching: boolean
  error: unknown
}

// Sanctioned hydration read (Feature-Set-Composition pattern) — the
// required-param query config only fires once a chain is selected.
export const useQuerySessionApproverChoices = ({
  sessionId,
  approvalChainId,
  onError,
}: IUseQuerySessionApproverChoicesParams): IUseQuerySessionApproverChoicesReturn => {
  const { data, isLoading, isFetching, error } = useQuery({
    ...reconcileSessionQueries.approverChoices(sessionId, approvalChainId ?? 0),
    enabled: approvalChainId != null,
    onError,
  })

  const choices = useMemo(
    () =>
      (data ?? []).map((constructor) => new SessionApproverChoice(constructor)),
    [data]
  )

  return {
    choices,
    isLoading,
    isFetching,
    error,
  }
}
